import { errorMessages } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import React from "react";
import { Create, SimpleForm, useNotify, useStore } from "react-admin";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import CreateForm from "./CreateForm";

const STORE_KEY = "internshipIndividualSchedule.filters";

const CreateScheduleIndividualSlot = () => {
  const [filters] = useStore(STORE_KEY, null);
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notify = useNotify();

  const transform = data => ({
    internshipSessionId: data.internshipSessionId,
    planId: data.planId,
    disciplineId: data.disciplineId,
    roomId: data.roomId,
    boxesCount: data.boxesCount,
    timeIntervals: data.timeIntervals,
    dateType: data.dateType,
  });

  return (
    <>
      <Create
        title="Създаване на индивидуално разписание"
        actions={<BackButtonToolbar />}
        transform={transform}
        onError={e => {
          const errorMessage = e.message || errorMessages[e.errorCode];
          notify(errorMessage, { type: "error" });
          handleConflictError(e);
        }}
      >
        <SimpleForm
          toolbar={<InactiveDeleteOptionEditToolbar />}
          defaultValues={{
            academicYearId: filters?.academicYearId,
            structuralUnitId: filters?.structuralUnitId,
            internshipSessionId: filters?.internshipSessionId,
            planId: filters?.planId,
          }}
        >
          <CreateForm filters={filters} />
        </SimpleForm>
      </Create>
      <ConflictErrorDialog />
    </>
  );
};

export default CreateScheduleIndividualSlot;
